import {useCallback} from 'react';
import CustomizedSwitches from '../../../../../components/styles/ToggleButton';
import {useStoreSelector} from '../../../../../store/configstore';
import {apiPut} from '../../../../../axiosConfig';
import {IStation} from '../../../../../dto/Station.dto';
import {companyIdSelector} from '../../../../../store/Slices/companySlice';
import Toast from '../../../../../package/Toaster';
import {Box, Typography} from '@mui/material';
import {useQueryClient} from '@tanstack/react-query';

type props = {
  custom_music_mix: 0 | 1;
  stationId: number;
  setSelectedStation: React.Dispatch<React.SetStateAction<IStation | null>>;
};

const MusicMixUpdateSwitch = ({
  custom_music_mix,
  stationId,
  setSelectedStation,
}: props) => {
  const companyId = useStoreSelector(companyIdSelector);
  const queryClient = useQueryClient();
  const handleChange = useCallback(
    (_e: React.SyntheticEvent<Element, Event>, checked: boolean) => {
      apiPut(`/v1/company/${companyId}/station/${stationId}`, {
        custom_music_mix: checked ? 1 : 0,
      }).then(() => {
        setSelectedStation(prev => {
          if (checked) {
            return {
              ...prev,
              custom_music_mix: 1,
            } as IStation;
          }
          return {...prev, custom_music_mix: 0} as IStation;
        });
        queryClient.invalidateQueries({
          queryKey: ['api/v1/company', Number(companyId), 'stations'],
          refetchType: 'active',
        });
        Toast(`Edit Music Mix ${checked ? 'enabled' : 'disabled'}`, 'success');
      });
    },
    [setSelectedStation, companyId, stationId, queryClient],
  );

  return (
    <Box className='flex items-center'>
      <CustomizedSwitches
        isActive={Boolean(custom_music_mix)}
        onChange={handleChange}
      />
      <Typography>
        {custom_music_mix
          ? 'Edit Music Mix is enabled'
          : 'Edit Music Mix is disabled'}
      </Typography>
    </Box>
  );
};

export default MusicMixUpdateSwitch;
